import { IUser } from 'src/interfaces/user.interface';

export class UserModel implements IUser {
  user?: string;
  password?: string;
  dtatualizacao?: string;
  email?: string;
  hash?: string;
  id?: string;
  inspectormaster?: string;
  isadministrador?: string;
  isativo?: string;
  ismaster?: string;
  login?: string;
  name?: string;

  public static fromJson(js: IUser) {
    let obj = new UserModel();
    obj.user = js.user;
    obj.password = js.password;
    obj.dtatualizacao = js.dtatualizacao;
    obj.email = js.email;
    obj.hash = js.hash;
    obj.id = js.id;
    obj.inspectormaster = js.inspectormaster;
    obj.isadministrador = js.isadministrador;
    obj.isativo = js.isativo;
    obj.ismaster = js.ismaster;
    obj.login = js.login;
    obj.name = js.name;
    return obj;
  }

  public toJsonLogin() {
    return {
      user: this.user,
      pass: this.password,
    };
  }
}
